import { Mail, Phone, ScanLine } from "lucide-react";
import { Reveal } from "./Reveal";
import { Logo, Wordmark } from "./Logo";
import { EMAIL, MAILTO, PHONE_DISPLAY, PHONE_TEL, SCAN_URL } from "../lib/site";

export const Footer = () => (
  <footer id="contact" className="relative overflow-hidden pt-24 pb-32 md:pb-16">
    <div className="absolute inset-0 -z-10">
      <img
        src="https://images.unsplash.com/photo-1607944023281-309f2751df84?auto=format&fit=crop&w=1600&q=80"
        alt=""
        className="h-full w-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/80 to-ink" />
    </div>

    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <Reveal className="text-center">
        <img
          src="/411techsavvy.jpg"
          alt="411techsavvy Technology — Veteran Owned Business — 623.291.8020"
          data-testid="footer-411techsavvy-image"
          className="mx-auto mt-2 w-full max-w-md rounded-2xl border border-white/15 shadow-2xl shadow-black/50"
        />
        <p className="mx-auto mt-6 max-w-xl text-base sm:text-lg text-slate-300">
          Get your free scan today, or call Eddie directly. Every customer deserves a website they can use — including
          yours.
        </p>
        <a
          data-testid="footer-scan-cta-button"
          href={SCAN_URL}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="mt-8 inline-flex items-center gap-3 rounded-full bg-brandamber px-8 py-4 text-base font-bold text-ink shadow-lg shadow-brandamber/25 transition-all hover:scale-[1.03] active:scale-95"
        >
          <ScanLine className="h-5 w-5" /> Get My FREE Scan
        </a>
      </Reveal>

      <Reveal delay={0.1} className="mt-14">
        <div className="grid gap-4 lg:grid-cols-2">
          <a
            data-testid="footer-phone-link"
            href={PHONE_TEL}
            className="group flex items-center gap-3 rounded-2xl border border-cy/30 bg-panel p-4 transition-all hover:border-cy hover:bg-cy/5 sm:gap-4 sm:p-6"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cy/10 sm:h-12 sm:w-12">
              <Phone className="h-5 w-5 text-cy" />
            </span>
            <span>
              <span className="block font-mono text-[10px] font-bold tracking-[0.25em] text-slate-300">CALL OR TEXT EDDIE</span>
              <span className="mt-1 block whitespace-nowrap text-lg font-semibold text-white group-hover:text-cy sm:text-xl">{PHONE_DISPLAY}</span>
            </span>
          </a>
          <a
            data-testid="footer-email-link"
            href={MAILTO}
            className="group flex items-center gap-3 rounded-2xl border border-brandamber/30 bg-panel p-4 transition-all hover:border-brandamber hover:bg-brandamber/5 sm:gap-4 sm:p-6"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brandamber/10 sm:h-12 sm:w-12">
              <Mail className="h-5 w-5 text-brandamber" />
            </span>
            <span className="min-w-0">
              <span className="block font-mono text-[10px] font-bold tracking-[0.25em] text-slate-300">EMAIL US ANYTIME</span>
              <span className="mt-1 block whitespace-nowrap text-[clamp(10px,3vw,14px)] font-semibold text-white group-hover:text-brandamber sm:text-sm md:text-lg">
                {EMAIL}
              </span>
            </span>
          </a>
        </div>
      </Reveal>

      <div className="mt-16 flex flex-col items-center gap-4 border-t border-white/10 pt-8 text-center">
        <div className="flex items-center gap-3">
          <Logo className="h-9 w-9" />
          <Wordmark />
        </div>
        <p className="font-mono text-[10px] font-bold tracking-[0.2em] text-slate-400">
          © 2026 EDDIE KIRK · ADA COMPLIANCE TECH ADVOCATE · 411TECHSAVVY · WECARE ADA
        </p>
        <p className="max-w-lg text-xs font-semibold leading-relaxed text-slate-400">
          No tool can promise a site will never be sued — we help you close real gaps, welcome every visitor and show
          the world you care.
        </p>
      </div>
    </div>
  </footer>
);
